
import {defineComponent} from 'vue'
import {ReportChart, ReportChartOption} from '@/model/models'
import {Chart, registerables} from 'chart.js'
import {BarChart} from 'vue-chart-3'

Chart.register(...registerables)

export default defineComponent( {
  name: 'ReportBarChart',
  components: {
    BarChart
  },
  props: {
    chart: ReportChart,
    chartData: {}
  },
  computed: {
    chartOptions() {
      return {
        // For chart options see https://www.chartjs.org/docs
        responsive: true,
        borderRadius: 10,
        borderWidth: 1,
        scales: {
          x: {
            stacked: this.chart!.options.indexOf(ReportChartOption.Stacked) >= 0
          },
          y: {
            stacked: this.chart!.options.indexOf(ReportChartOption.Stacked) >= 0
          }
        },
        indexAxis: this.chart!.options.indexOf(ReportChartOption.Horizontal) >= 0 ? 'y' : 'x',
        plugins: {
          legend: {
            display: this.chart!.options.indexOf(ReportChartOption.Legend) >= 0,
            position: 'top'
          },
          tooltip: {
            padding: 10,
            boxPadding: 10
          },
          datalabels: {
            // For label options see https://chartjs-plugin-datalabels.netlify.app
            display: false
          }
        }
      }
    }
  }
})
